export const API_URL = 'https://kudoslive.rw/api';
export const API_FILE_URL = 'https://kudoslive.rw/api/uploads';
export const SOCKET_URL = 'https://kudoslive.rw';
export const GOOGLE_API_KEY = 'AIzaSyBzMwTmxBerGncywrE2anIr_0Zf5ctucas'